import "./App.scss";
import { components } from "./theme";
import { ConfigProvider,message} from "antd";
import { AdminRouter } from "./router";
import {Suspense, useEffect} from "react";
import {useTranslation} from "react-i18next";
import { useNavigate } from "react-router-dom"; // 引入 useNavigate

function App() {
    const {t} = useTranslation();
    const navigate = useNavigate(); // 获取 navigate 函数
    useEffect(() => {
        // 设置初始活动时间
        const initTime = new Date().getTime();
        sessionStorage.setItem("nowTime", initTime.toString());

        // 添加body点击事件监听器
        const handleBodyClick = () => {
            // 排除登录相关页面的检查
            const loginPaths = ["/login", "/register", "/forgot-password"];
            if (loginPaths.includes(window.location.pathname)) {
                // 在登录相关页面也更新活动时间
                const now = new Date().getTime();
                sessionStorage.setItem("nowTime", now.toString());
                return;
            }
            // 点击时检查是否过期
            const clickTime = sessionStorage.getItem("nowTime")
                ? Number(sessionStorage.getItem("nowTime"))
                : null;
            const time = new Date().getTime();
            if (clickTime && (time - clickTime >= 2 * 60 * 60 * 1000)) {
                // 过期了，提示并跳转
                // 先显示提示框，提示登录过期
                message.open({
                    type: "error",
                    content: t("login.Login expired!"),
                    duration: 3, // 显示3秒
                });
                localStorage.clear();
                sessionStorage.removeItem("nowTime");
                setTimeout(() => {
                    navigate("/login");
                }, 3000); // 延迟1秒跳转
            }

            // 更新用户活动时间
            const now = new Date().getTime();
            console.log("点击时间==", now);
            sessionStorage.setItem("nowTime", now.toString());

        };

        // const intervalId = setInterval(() => {
        //     const clickTime = sessionStorage.getItem("nowTime")
        //         ? Number(sessionStorage.getItem("nowTime"))
        //         : null;
        //     const time = new Date()?.getTime();
        //     if (clickTime) {
        //         if (time - clickTime >= 10 * 1000) {
        //             // 先显示提示框，提示登录过期
        //             message.open({
        //                 type: "error",
        //                 content: t("login.Login expired!"),
        //                 duration: 1, // 显示3秒
        //             });
        //             localStorage.clear();
        //
        //             // 清除定时器，防止重复触发
        //             clearInterval(intervalId);
        //
        //             // 延迟跳转，给提示框显示的时间
        //             setTimeout(() => {
        //                 navigate("/login");
        //             }, 1000); // 延迟2秒跳转
        //         }
        //     }
        // }, 1000);
        // 添加事件监听器
        document.body.addEventListener("click", handleBodyClick);

        // 清理函数
        return () => {
            document.body.removeEventListener("click", handleBodyClick);
            // clearInterval(intervalId); // 清除定时器
        };
    }, []);


    // 从sessionStorage中获取本地化标识
    const local = sessionStorage.getItem("local")!;

    // 监听local值的变化，当存在local值时设置页面标题
    useEffect(()=>{
        if(local){
            document.title = t("page.title");
        }
    },[local])

  return (
    <div className="App">
      <ConfigProvider
        theme={{
          components,
        }}
      >
        <Suspense>
          <AdminRouter />
        </Suspense>
      </ConfigProvider>
    </div>
  );


}

export default App;
